<template>
    <div>
        <!-- DESARROLLLO INICIADO EL MARTES 28 DE JULIO -->
        <!-- boton crear -->
        <v-row v-if="componenteEvento.agregar_submodulo">
            <v-col class="d-flex flex-row-reverse">
                <CommonButtons @click="addItem" textButton="Crear
                    configuración de nota literal" iconBut="fas fa-plus" normalButton/>
            </v-col>
            <v-col cols="12">
                <ComundataTablecomp :headers="NotaliteralHeaders" whitSearch :items="Datos" :search="search">
                    <template v-slot>
                        <v-row dense>
                            <v-col cols="12" md="4">
                                <AutocompleteComp @change="getAllConfigNotasNumericas(filtro.ano_lectivo)" textLabel="Año lectivo"
                            :items="anios_lectivos" item-value="id" item-text="nom_anolectivo"
                            v-model="filtro.ano_lectivo" />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:literal="{ item }">
                        <v-chip :color="item.color_nota" class="texto_white" label>{{ item.literal }}</v-chip>
                    </template>
                    <template v-slot:nota_max="{ item }">
                        <v-chip :color="item.color_nota" class="texto_white" label>{{ item.nota_max_visualizar }}</v-chip>
                    </template>
                    <template v-slot:nota_min="{ item }">
                        <v-chip :color="item.color_nota" class="texto_white" label>{{ item.nota_min_visualizar }}</v-chip>
                    </template>

                    <template v-slot:Descripcion="{ item }">
                        <v-menu absolute offset-y style="max-width: 600px">
                            <template v-slot:activator="{ on }">
                                <v-row justify="space-around" v-on="on" style="cursor: pointer">
                                    <v-icon color="primary">fas fa-comments</v-icon>
                                </v-row>
                            </template>

                            <v-card max-width="250px" class="py-2 px-2">
                                <v-tooltip bottom color="#1b1b1b">
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on">{{ item.descripcion + '.' }}</span>
                                    </template>
                                </v-tooltip>
                            </v-card>
                        </v-menu>
                    </template>


                    <template v-slot:action_editar="{ item }">
                        <CommonButtons v-if="componenteEvento.editar_submodulo" @click="editItem(item)" editButton
                            tooltipText="Editar nota" />
                    </template>

                    <template v-slot:action_borrar="{ item }">
                        <CommonButtons v-if="componenteEvento.borrar_submodulo" @click="deleteConfirm(item)" deleteButton
                            tooltipText="Eliminar nota" />
                    </template>
                </ComundataTablecomp>
            </v-col>
        </v-row>
        <!-- fin boton  crear-->



        <!-- /////////////////////////////////////////////////////
            //             PANTALLA PRINCIPAL    //
            /////////////////////////////////////////////////////    -->

        <!-- fin de pantalla principal -->





        <!-- /////////////////////////////////////////////////////
             //     MODAL DE AGREGAR O EDITAR          //
        ////////////////////////////////////////////////////    -->
        <v-form ref="formDatos" lazy-validation>
            <CommonDialog v-model="dialog" maxWidth="650" :title="formTitle" @close-modal="dialog = false">
                <template v-slot:body>
                    <v-card-text>

                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-select label="Nota literal" v-model="dataForm.id_calif_litera" :items="NotaLiteral"
                                    item-text="literal" item-value="id" @change="loadNotaLiteral(dataForm.id_calif_litera)"
                                    :rules="validationRules.validateCampoList" :readonly="bloquearCampo">
                                </v-select>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-text-field v-model="dataForm.interpretacion" label="Interpretación"
                                    ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-text-field v-model="dataForm.nota_min" type="number" label="Equivalencia númerica mínima"
                                    :rules="validationRules.validateCampo" @keypress="soloNumeros($event)" @input="validateAndCorrectMinMax('nota_min')"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-text-field v-model="dataForm.nota_max" type="number" label="Equivalencia númerica máxima"
                                    :rules="validationRules.validateCampo" @keypress="soloNumeros($event)" @input="validateAndCorrectMinMax('nota_max')"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-textarea v-model="dataForm.descripcion" label="Descripción" rows="2"></v-textarea>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-checkbox color="#01579b" v-model="dataForm.conclusion"
                                    label="Agregar conclusión descriptiva"></v-checkbox>
                            </v-col>

                            <v-col cols="12" sm="12">
                                <v-row class="mb-3">
                                    <v-col>
                                        <label class="black--text">
                                            <h3>Seleccionar color</h3>
                                        </label>
                                    </v-col>
                                </v-row>

                                <v-color-picker v-model="dataForm.color_nota" width="400px"></v-color-picker>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-divider></v-divider>

                </template>
                <template v-slot:actions>
                    <v-spacer></v-spacer>
                    <CommonButtons v-if="evento == 'editar'" @click="saveItem(dataForm.id)" textButton="Guardar Cambios"
                        iconBut="fas fa-save" normalButton></CommonButtons>
                    <CommonButtons v-if="evento == 'agregar'" @click="saveItem" textButton="Guardar" iconBut="fas fa-save"
                        normalButton></CommonButtons>
                </template>
            </CommonDialog>

        </v-form>
        <!-- fin de modal agregar o editar perfil -->






        <!-- /////////////////////////////////////////////////////
        //         MODAL DE ELIMINAR REGISTROS                  //
        /////////////////////////////////////////////////////    -->
        <CommonDialog Deletedialog v-model="dialog_delete" titleWindow="Eliminar nota literal"
            @close-modal="dialog_delete = false" @delete-item="deleteItem" @cancel-item="dialog_delete = false">
            <template v-slot:body>
                ¿Está seguro de eliminar este registro?
            </template>
        </CommonDialog>

        <!-- fin de modal de eliminar registro -->

    </div>
</template>


<script>

import axios from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from 'vuex';
import CommonDialog from "../../../../components/ComponentsEst/ComunDialogComp.vue";
import CommonButtons from "../../../../components/ComponentsEst/TableButtonComp.vue";
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import { NotaliteralHeaders } from '../../../../helpers/headersTable';
import { validationRules } from '../../../../helpers/validatorHelpers';

export default {
    name: 'formNotaLit',

    props: ['parametros', 'anios_lectivos'],

    components: {
        CommonDialog,
        CommonButtons,
        ComundataTablecomp,
        AutocompleteComp
    },

    data: () => ({
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        paramComponente: { 'id_submodulo': 86, "id_modulo": 5 }, //sud_modulo y modulo

        datoLogin: sessionStorage, // variables de sesion del usuario
        ////////////////////////////////////////////////////////
        NotaliteralHeaders,
        filtro: [],
        search: '',
        Datos: [],  

        //validaciones de formulario 
        // MODAL AGREGRAR-EDITAR NOTA LITERAL
        evento: null,
        titulo: ' configuración de nota literal',
        dialog: false,
        formTitle: '',
        bloquearCampo: false,
        dataForm: [],
        NotaLiteral: [],
        ///////////////////////////////
        // MODAL ELIMINAR NOTA LITERAL
        dialog_delete: false,
        desc_delete: null,
        id_delete: null,
        ///////////////////////////////
        dataRangoNotas: {
        nota_min: null,
        nota_max: null,
        },
        validationRules: {
            validateCampo: [
            value => !!value || 'Campo requerido',
            value => value >= 0 || 'El valor debe ser 0 o mayor',
            value => value <= 20 || 'El valor no puede exceder 20'
            ]
        }
    }),
    computed: {
        ...mapGetters('login', ['componenteEvento']),

        validationRules(){
            return validationRules;
        }
    },


    mounted() {
        this.loadMain()
    },


    created() {
        this.actualizarParamentro()
    },


    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        //----- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },

        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ////////////////////////////////////////////////////////


        // funcion para solo permitir numeros
        soloNumeros(event) {
            var key = window.event ? event.which : event.keyCode

            if (key < 48 || key > 57) {
                event.preventDefault()
            }
        },

        validateAndCorrectMinMax(field) {
            const minValue = 0;
            const maxValue = 20;
            if (this.dataForm[field] < minValue) {
                this.dataForm[field] = minValue;
            } else if (this.dataForm[field] > maxValue) {
                this.dataForm[field] = maxValue;
            }
        },
        /** 
         ________________________________________________________
        |          MÉTODO OBTENER TODOS LOS REGISTROS          */   
        async loadMain() {
            try {
                let params = { "id_colegio": this.datoLogin.id_colegio, "id_ano_lectivo": sessionStorage.id_ano_lectivo }
                let response = await axios.post("/administrativo/confNotaLiteral/getConfiguracionLiteral/", params)
                this.Datos = response.data;
            }
            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },



        //////consultar configuracion de nota segun año lectivo/////
        async getAllConfigNotasNumericas(id) {

            let params = {
                "id_colegio": sessionStorage.id_colegio,
                "id_ano_lectivo": id
            }

            try {
                let response = await axios.post("/administrativo/confNotaLiteral/getConfiguracionLiteral/", params)
                this.Datos = response.data

            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },
        ////////////////////////////////////////////////////////////



        async limpiarForm() {
            this.dataForm = {
                id_colegio: sessionStorage.id_colegio,
                id_calif_litera: null,
                id_ano_lectivo: sessionStorage.id_ano_lectivo,
                interpretacion: '',
                nota_min: null,
                nota_max: null,
                descripcion: '',
                conclusion: false,
                conclusion_desc: null,
                color_nota: '#0277BD',
                id_us_ing: sessionStorage.id,
            }

            this.NotaLiteral = []
            this.bloquearCampo = false

            this.$refs.formDatos.resetValidation()
        },




        //----------- AREGAR REGISTROS  --------------
        async addItem() {
            this.limpiarForm()
            this.formTitle = "Crear" + this.titulo
            this.dialog = true
            this.evento = 'agregar'
            this.bloquearCampo = false

            this.getAllNotaLiteral()
        },


        //---------traer nota literal-----------------
        async getAllNotaLiteral() {
            try {
                let response = await axios.get("/mantenimiento/confCalificacionLiteral/")
                this.NotaLiteral = response.data
            }

            catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null })
            }
        },



        async loadNotaLiteral(id) {
            try {
                let response = await axios.get("/mantenimiento/confCalificacionLiteral/" + id)
                this.dataForm.interpretacion = response.data.interpretacion
                this.dataForm.nota_min = response.data.nota_min
                this.dataForm.nota_max = response.data.nota_max
                this.dataForm.descripcion = response.data.descripcion
            }

            catch (e) {
                this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null })
            }
        },


        // Guardar registro
        async saveItem(id) {
            if (this.$refs.formDatos.validate()) {
                if (this.dataForm.conclusion === true) {
                    this.dataForm.conclusion_desc = 1
                }

                else {
                    this.dataForm.conclusion_desc = 0
                }


                try {
                    if (this.evento == "agregar") {
                        let res = await axios.post("/administrativo/confNotaLiteral/addeNotaLiteral/", this.dataForm)

                        if (res.data.messageT == "S") {
                            this.loadMain()
                            this.dialog = false
                            this.limpiarForm()
                        }

                        this.setEnviarMens({ tipo: res.data.messageT, mensaje: `${res.data.message}`, tiempo: null })
                    }

                    else {
                        let res = await axios.put("/administrativo/confNotaLiteral/" + id, this.dataForm)

                        if (res.data.messageT == "S") {
                            this.loadMain()
                            this.dialog = false
                            this.limpiarForm()
                        }

                        this.setEnviarMens({ tipo: res.data.messageT, mensaje: `${res.data.message}`, tiempo: null })
                    }
                }

                catch (error) {
                    let mensajeError = 'Se ha producido un error al guardar los datos';
                    // Verificar si el error viene con una respuesta del servidor y extraer el mensaje
                    if (error.response && error.response.data && error.response.data.message) {
                        mensajeError = error.response.data.message;
                    } else if (error.message) {
                        mensajeError = error.message;
                    }
                    this.setEnviarMens({ tipo: "E", mensaje: mensajeError, tiempo: 3000 });
                }
            }

            else {
                this.setEnviarMens({ tipo: "W", mensaje: `Debe de ingresar todos los campos requeridos`, tiempo: null })
            }
        },



        //--------------EDITAR REGISTRO--------------
        editItem(item) {
            this.limpiarForm()
            this.formTitle = "Editar " + this.titulo
            this.dialog = true
            this.evento = "editar"
            this.bloquearCampo = true

            this.getAllNotaLiteral()

            this.dataForm.conclusion == true ? item.conclusion_desc === 1 : false;
            item.id_us_mod = this.datoLogin.id
            this.dataForm = Object.assign({}, item)
        },






        // activa la modal para confirmar el eliminar el registro
        deleteConfirm(items) {
            this.dialog_delete = true
            this.id_delete = items.id
        },



        //------------ELIMINAR Registro -------------
        async deleteItem() {
            this.dialog_delete = false

            try {
                let resp = await axios.delete("/administrativo/confNotaLiteral/" + this.id_delete)

                if (resp.data.messageT == "S") {
                    this.loadMain()
                    this.dialog_delete = false
                }

                this.setEnviarMens({ tipo: resp.data.messageT, mensaje: `${resp.data.message}`, tiempo: null })
            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },





    },
}
</script>

<style scoped>
.texto_white {
    font-size: 14px;
    font-weight: bold;
    color: #fff !important;
}
</style>

